(function () {
  var thumbs = document.querySelectorAll('[data-pdp-thumb]');
  var mainWrap = document.getElementById('pdp-main-image');
  var main = document.getElementById('pdp-featured-image') || (mainWrap ? mainWrap.querySelector('img') : null);
  var shadeHeroLabel = document.querySelector('[data-pdp-shade-hero-label]');
  var variantSelect = document.querySelector('[data-pdp-variant-select]');
  var shadePicker = document.querySelector('[data-pdp-shade-picker]');
  var variantIdInput = document.querySelector('[data-pdp-variant-id]');
  var labelsNode = document.getElementById('pdp-variant-labels');
  var labels = {
    addToBag: '',
    soldOut: '',
    closeImage: 'Close image',
    zoomImage: 'Zoom product image',
    productImage: 'Product image',
  };
  if (labelsNode) {
    try {
      Object.assign(labels, JSON.parse(labelsNode.textContent));
    } catch (err) {
      console.error('PDP variant labels JSON invalid', err);
    }
  }

  function setMainImage(src) {
    if (!main || !src) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = src;
  }

  function setShadeHeroVisible(visible) {
    if (shadeHeroLabel) shadeHeroLabel.hidden = !visible;
  }

  function syncSwatchSelection(variantId) {
    if (!shadePicker || !variantId) return;
    var swatches = shadePicker.querySelectorAll('[data-pdp-swatch]');
    swatches.forEach(function (swatch) {
      var match = swatch.getAttribute('data-variant-id') === String(variantId);
      swatch.classList.toggle('is-selected', match);
      swatch.setAttribute('aria-selected', match ? 'true' : 'false');
    });
  }

  function syncThumbSelection(variantId) {
    if (!variantId) return;
    thumbs.forEach(function (thumb) {
      var match = thumb.getAttribute('data-variant-id') === String(variantId);
      thumb.classList.toggle('active', match);
    });
  }

  function updateVariantUiFromData(data, options) {
    options = options || {};
    var priceEl = document.querySelector('[data-pdp-price]');
    var compareEl = document.querySelector('[data-pdp-compare]');
    var submitBtn = document.querySelector('[data-pdp-submit]');
    var available = data.available === true || data.available === 'true';
    var price = data.price;
    var compareAt = data.compareAt || '';

    if (priceEl && price) priceEl.textContent = price;

    if (compareEl) {
      if (compareAt) {
        compareEl.textContent = compareAt;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }

    if (submitBtn) {
      submitBtn.disabled = !available;
      submitBtn.textContent = available ? labels.addToBag : labels.soldOut;
    }

    if (data.image && !options.skipImage) setMainImage(data.image);

    if (data.variantId) {
      if (variantIdInput) variantIdInput.value = data.variantId;
      if (variantSelect) variantSelect.value = data.variantId;
      syncSwatchSelection(data.variantId);
      if (!options.skipThumb) syncThumbSelection(data.variantId);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', data.variantId);
      window.history.replaceState({}, '', url.toString());
    }

    if (data.shadeName) {
      var selectedLabel = document.querySelector('[data-pdp-shade-selected]');
      if (selectedLabel) selectedLabel.textContent = data.shadeName;

      var heroName = document.querySelector('[data-pdp-shade-hero-name]');
      if (heroName) heroName.textContent = data.shadeName;

      setShadeHeroVisible(true);

      if (main) {
        var baseAlt = main.getAttribute('data-base-alt') || main.alt || '';
        if (!main.getAttribute('data-base-alt')) main.setAttribute('data-base-alt', baseAlt);
        main.alt = data.shadeName + ' — ' + baseAlt.replace(/^[^—]+—\s*/, '');
      }
    }
  }

  if (thumbs.length && main) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (!src) return;

        setMainImage(src);
        thumbs.forEach(function (t) {
          t.classList.remove('active');
        });
        thumb.classList.add('active');

        var shadeName = thumb.getAttribute('data-shade-name');
        var variantId = thumb.getAttribute('data-variant-id');

        if (shadeName && variantId) {
          updateVariantUiFromData(
            {
              available: thumb.getAttribute('data-variant-available'),
              price: thumb.getAttribute('data-variant-price'),
              compareAt: thumb.getAttribute('data-variant-compare'),
              variantId: variantId,
              shadeName: shadeName,
            },
            { skipImage: true, skipThumb: true }
          );
        } else {
          setShadeHeroVisible(false);
        }
      });
    });
  }

  if (main && mainWrap) {
    var lightbox = null;

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.remove();
      lightbox = null;
      document.removeEventListener('keydown', onLightboxKey);
      document.body.style.overflow = '';
    }

    function onLightboxKey(e) {
      if (e.key === 'Escape') closeLightbox();
    }

    function openLightbox() {
      if (lightbox) return;
      lightbox = document.createElement('div');
      lightbox.className = 'pdp-lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.setAttribute('aria-label', main.alt || labels.productImage);

      var img = document.createElement('img');
      img.src = main.currentSrc || main.src;
      img.alt = main.alt || '';

      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'pdp-lightbox-close';
      close.setAttribute('aria-label', labels.closeImage);
      close.innerHTML = '&times;';

      lightbox.appendChild(img);
      lightbox.appendChild(close);
      lightbox.addEventListener('click', closeLightbox);
      document.addEventListener('keydown', onLightboxKey);
      document.body.appendChild(lightbox);
      document.body.style.overflow = 'hidden';
      close.focus();
    }

    mainWrap.style.cursor = 'zoom-in';
    mainWrap.addEventListener('click', openLightbox);
    mainWrap.setAttribute('tabindex', '0');
    mainWrap.setAttribute('role', 'button');
    mainWrap.setAttribute('aria-label', labels.zoomImage);
    mainWrap.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openLightbox();
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pdp-qty-change]');
    if (!btn) return;

    e.preventDefault();
    var input = document.getElementById('pdp-quantity');
    if (!input) return;

    var min = parseInt(input.min, 10) || 1;
    var max = input.max ? parseInt(input.max, 10) : null;
    var step = parseInt(input.step, 10) || 1;
    var current = parseInt(input.value, 10) || min;
    var direction = btn.getAttribute('data-pdp-qty-change') === 'increase' ? 1 : -1;
    var next = current + direction * step;

    if (next < min) next = min;
    if (max && next > max) next = max;
    input.value = String(next);
  });

  function updateVariantUiFromSelect() {
    if (!variantSelect) return;
    var option = variantSelect.options[variantSelect.selectedIndex];
    if (!option) return;
    updateVariantUiFromData({
      available: option.getAttribute('data-available'),
      price: option.getAttribute('data-price'),
      compareAt: option.getAttribute('data-compare-at'),
      image: option.getAttribute('data-image'),
      variantId: option.value,
      shadeName: option.getAttribute('data-shade-name') || option.textContent.split(' · ')[0],
    });
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', updateVariantUiFromSelect);
  }

  if (shadePicker) {
    var swatches = shadePicker.querySelectorAll('[data-pdp-swatch]');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.disabled) return;

        updateVariantUiFromData({
          available: swatch.getAttribute('data-variant-available'),
          price: swatch.getAttribute('data-variant-price'),
          compareAt: swatch.getAttribute('data-variant-compare'),
          image: swatch.getAttribute('data-variant-image'),
          variantId: swatch.getAttribute('data-variant-id'),
          shadeName: swatch.getAttribute('data-shade-name'),
        });
      });
    });
  }

  function initVariantFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId) return;

    if (shadePicker) {
      var swatch = shadePicker.querySelector('[data-pdp-swatch][data-variant-id="' + variantId + '"]');
      if (swatch && !swatch.disabled) {
        swatch.click();
        return;
      }
    }

    if (variantSelect) {
      var option = variantSelect.querySelector('option[value="' + variantId + '"]');
      if (option) {
        variantSelect.value = variantId;
        updateVariantUiFromSelect();
        return;
      }
    }

    thumbs.forEach(function (thumb) {
      if (thumb.getAttribute('data-variant-id') === String(variantId)) {
        thumb.click();
      }
    });
  }

  initVariantFromUrl();
})();
